module.exports = __webpack_public_path__ + "img/yqzl (4).ad522922.png";